/* eslint-disable array-callback-return */
/* eslint-disable no-shadow */
/* eslint-disable prefer-destructuring */
import { call, all, put, takeLatest } from 'redux-saga/effects';
import * as Actions from './actions';
import * as Constants from './Constants';
import { logError, FE_API_ERROR, FE_API_JS_ERROR } from '../../services/loggerService';
import { store } from '../../configureStore';
import { getSession } from '../../components/common/Helpers';
import { showLoader, hideLoader } from '../../components/common/Helpers/loader';

function* postSwithToFRP({ data }) {
  yield put({ type: Constants.ASYNC_FETCH });
  try {
    showLoader();
    const apiResponse = yield call(Actions.swithToFRPApi, data);
    if (apiResponse && apiResponse.data && !apiResponse.data.errors) {
      yield put({ type: Constants.GET_DATA_SUCCESS, response: apiResponse.data });
      yield put({ type: 'GET_CART_AFTER_FRP', data: getSession('cartExist') });
    } else {
      logError('postSwithToFRP', apiResponse.data.errors, FE_API_ERROR);
    }
  } catch (error) {
    hideLoader();
    yield put({ type: Constants.ERR_OCCURED });
    logError('getDataFromApi', error, FE_API_JS_ERROR);
  }
  yield put({ type: Constants.ASYNC_FETCH_SUCCESS });
}

function* retrivecartAfterFRP({ data }) {
  yield put({ type: Constants.ASYNC_FETCH });
  try {
    showLoader();
    const apiResponse = yield call(Actions.getCartDetails, data); // TODO: Need to change function name
    if (apiResponse && apiResponse.data && !apiResponse.data.errors) {
      store.dispatch({ type: 'GET_CART_SUCCESS', response: apiResponse.data });
      hideLoader();
    } else {
      logError('retrivecartAfterFRP', apiResponse.data.errors, FE_API_ERROR);
    }
  } catch (error) {
    hideLoader();
    yield put({ type: Constants.ERR_OCCURED });
    logError('retrivecartAfterFRP', error, FE_API_JS_ERROR);
  }
  yield put({ type: Constants.ASYNC_FETCH_SUCCESS });
}

function* actionWatcher() {
  yield takeLatest('SWITCH_TO_FRP', postSwithToFRP);
  yield takeLatest('GET_CART_AFTER_FRP', retrivecartAfterFRP);
}

export default function* rootSaga() {
  yield all([actionWatcher()]);
}
